import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class Progress {
    private name: string;
    private start: string;
    private end: string;
    private property: string;

    constructor(private element: HTMLElement, private data: string[] | null = null) {
        this.init();
    }

    private init() {
        const attr = this.element.getAttribute('data-progress');
        if (!attr && !this.data) return;

        if (!this.data) {
            this.data = attr!.split('|');
        }

        this.name = this.data[0] || "";
        this.start = this.data[1] || "top bottom";
        this.end = this.data[2] || "bottom top";
        this.property = this.name ? `--progress-${this.name.toLowerCase().replace(/\s+/g, '_')}` : '--progress';

        this.createTrigger();
    }

    private createTrigger() {
        const proxy = { value: 0 };

        const introTween = gsap.fromTo(proxy,
            { value: 0 },
            {
                value: 0,
                duration: 0.8,
                ease: "power2.out",
                paused: true,
                onUpdate: () => {
                    this.element.style.setProperty(this.property, proxy.value.toString());
                }
            }
        );

        const trigger = ScrollTrigger.create({
            trigger: this.element,
            start: this.start,
            end: this.end,
            scrub: true,
            onUpdate: (self) => {
                if (introTween.isActive()) {
                    introTween.vars.value = self.progress;
                    return;
                }
                this.element.style.setProperty(this.property, self.progress.toString());
            }
        });

        if (trigger.progress > 0) {
            introTween.vars.value = trigger.progress;
            introTween.play();
        }
    }
}